//Intention is to replace all of the <ListItemOption> items with this univeral one. 
//Any functionality beyond text and onClick() should be optional, to avoid updating a million files on change.

import * as React from 'react';
import { ListItemButton, ListItemText } from "@mui/material";

export interface Option {
  text: string | JSX.Element;
  disabled?: boolean;
  onClick: (any) => any;
  textStyle?: any;
  buttonStyle?: any;
  hoverStyle?: any;
  buttonId?: string;
}

export const MoreOptionsItem: React.FunctionComponent<Option> = props => {
  return (
    <ListItemButton
      onClick={props.onClick}
      disabled={props.disabled ?? false}
      style={props.buttonStyle}
      sx={{
        ":hover": {
          ...props.hoverStyle
        }
      }}
      id={props.buttonId}
    >
      <ListItemText disableTypography primary={props.text} style={props.textStyle} />
    </ListItemButton>
  );
}

export default MoreOptionsItem;